import React from 'react';
import { Book, CheckCircle } from 'lucide-react';
import { buddhaAndDhamma } from '../data/mock';

const BuddhaAndDhamma = () => {
  return (
    <section id="dhamma" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full">
              <Book className="w-4 h-4 text-orange-600" />
              <span className="text-sm font-semibold text-orange-700">Sacred Text</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              {buddhaAndDhamma.title}
            </h2>

            <p className="text-xl font-semibold text-orange-600">
              {buddhaAndDhamma.subtitle}
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              {buddhaAndDhamma.content}
            </p>

            {/* Key Points */}
            <div className="space-y-3 pt-4">
              {buddhaAndDhamma.keyPoints.map((point, index) => (
                <div key={index} className="flex items-start gap-3 group">
                  <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" />
                  <p className="text-gray-700 leading-relaxed group-hover:text-gray-900 transition-colors">
                    {point}
                  </p>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div className="pt-6">
              <a 
                href="https://www2.budaedu.org/dharma-data/book-efile/IN016-01-001.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-gradient-to-r from-orange-600 to-orange-700 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
              >
                Download the Book
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-orange-600 to-yellow-500 rounded-2xl transform -rotate-3"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img 
                src={buddhaAndDhamma.image} 
                alt="Buddhist Monks Education" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-orange-900/50 to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-4 -right-4 bg-white p-6 rounded-xl shadow-xl border-l-4 border-yellow-500">
              <p className="text-sm text-gray-600 mb-1">Published</p>
              <p className="text-2xl font-bold text-gray-800">1957</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuddhaAndDhamma;
